import React, { useEffect, useRef, useState } from "react";
import { ChevronDown, Check } from "lucide-react";

export function MultiSelect({ values = [], onChange, options, label, placeholder = "Any", testid }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const h = (e) => ref.current && !ref.current.contains(e.target) && setOpen(false);
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const toggle = (v) => {
    onChange(values.includes(v) ? values.filter((x) => x !== v) : [...values, v]);
  };

  const selectedLabels = options.filter((o) => values.includes(o.value)).map((o) => o.label);

  return (
    <div className="block" ref={ref}>
      {label && (
        <span className="block text-[11px] uppercase tracking-wider text-muted mb-1.5">{label}</span>
      )}
      <div className="relative">
        <button
          type="button"
          data-testid={testid}
          onClick={() => setOpen((o) => !o)}
          className="w-full min-h-9 px-3 py-1.5 flex items-center justify-between gap-2 bg-surface2 border border-line rounded-sm text-sm text-ink transition-colors duration-150 hover:border-lineFocus focus:outline-none focus:border-primary focus:ring-2 focus:ring-primary/40"
        >
          <span className={selectedLabels.length ? "text-ink text-left" : "text-faint"}>
            {selectedLabels.length ? selectedLabels.join(", ") : placeholder}
          </span>
          <ChevronDown className="w-4 h-4 text-muted shrink-0" />
        </button>
        {open && (
          <div className="absolute z-50 mt-1 w-full max-h-64 overflow-auto bg-surface2 border border-lineFocus rounded-sm shadow-2xl animate-fadeup">
            {options.map((o) => (
              <button
                key={o.value}
                type="button"
                data-testid={testid ? `${testid}-opt-${o.value}` : undefined}
                onClick={() => toggle(o.value)}
                className="w-full px-3 py-2 flex items-center justify-between text-left text-sm text-ink hover:bg-primary/15 transition-colors duration-100"
              >
                <span>{o.label}</span>
                {values.includes(o.value) && <Check className="w-3.5 h-3.5 text-primary" />}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
